import { render, staticRenderFns } from "./GameRemindersDropdown.vue?vue&type=template&id=6980a8de&"
import script from "./GameRemindersDropdown.vue?vue&type=script&lang=js&"
export * from "./GameRemindersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports